import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdCheck, MdSms, MdWhatsapp } from "react-icons/md";

export default function SubjectRegistrationForm({ data, callback }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [name, setName] = useState("");
	const [description, setDescription] = useState("");


	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	function resetForm() {
		setName("");
		setDescription('');
	}

	async function create() {
		if(name.trim().length > 0) {
			setLoading(true);
			await callApi(
				'create-subject',
				{
					name,
					description,
					schoolUuid: appContext.currentSchoolUuid,
				}
			).then(response => {
				if(response.status === 1) {
					appContext.getAllSubjects();
					appContext.tellMessage("Successful");
					resetForm()
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid name");
		}
	}

	async function edit() {
		if(name.trim().length > 0) {
			setLoading(true);
			await callApi(
				'edit-subject',
				{
					uuid: data.uuid,
					name,
					description,
					schoolUuid: appContext.currentSchoolUuid,
				}
			).then(response => {
				if(response.status === 1) {
					appContext.getAllSubjects();
					appContext.tellMessage("Successful");
					
					if(callback) {
						callback();
					}
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid name");
		}
	}

	useEffect(() => {
		if(data) {
			setName(data.name);
			setDescription(data.description);
		}
	}, [ data ])

	useEffect(() => {
		init();
	}, [])

	

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
		
			<div className="row">
				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Subject's Name</label>
					<input
						className="form-control"
						value={name}
						onChange={e => setName(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Subject's Description</label>
					<textarea
						className="form-control"
						value={description}
						onChange={e => setDescription(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2 text-end">
					<button
						className="btn btn-secondary"
						onClick={() => {
							if(data) {
								appContext.activateDialog({
									message: `Edit this subject?`,
									onConfirm: edit,
								})
							} else {
								appContext.activateDialog({
									message: `Create new subject, ${name}?`,
									onConfirm: create,
								})
							}
						}}
					>
						<MdCheck/> Submit
					</button>
				</div>
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}